module.exports = __webpack_public_path__ + "assets/gif-pr.png";


//////////////////
// WEBPACK FOOTER
// ./images/gif-pr.png
// module id = 296
// module chunks = 0